import { motion } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import GlassCard from '../shared/GlassCard';

export default function Certificates({ certificates }) {
  return (
        <section id="certificates" className="py-20 px-6 md:px-20 bg-white dark:bg-gray-900">
          <div className="max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, type: "spring" }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-10 text-gray-900 dark:text-white text-center">
                <span className="border-b-4 border-indigo-500 pb-1">Certificates</span>
              </h2>

              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                viewport={{ once: true }}
              >
                <GlassCard className="p-4 sm:p-6 md:p-8">
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
                    {certificates.map((certificate, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ delay: index * 0.1, duration: 0.5, type: "spring" }}
                        viewport={{ once: true }}
                        whileHover={{ y: -5 }}
                      >
                        <GlassCard className="p-6 h-full hover:shadow-lg transition-shadow duration-300">
                          <div className="flex items-start justify-between mb-3">
                            <div className="bg-indigo-100 dark:bg-gray-700 p-2 rounded-lg">
                              <img
                                src={certificate.logo || "https://via.placeholder.com/40"}
                                alt={certificate.issuer}
                                className="w-10 h-10 object-contain"
                              />
                            </div>
                            {certificate.verified && (
                              <motion.span
                                className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300 rounded-full flex items-center"
                                initial={{ scale: 0.9 }}
                                animate={{ scale: 1 }}
                                transition={{
                                  repeat: Infinity,
                                  repeatType: "reverse",
                                  duration: 1.5
                                }}
                              >
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                Verified
                              </motion.span>
                            )}
                          </div>

                          <h3 className="text-lg font-semibold text-indigo-800 dark:text-indigo-300 mb-1">
                            {certificate.title}
                          </h3>

                          <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                            {certificate.issuer}
                          </p>

                          <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
                            Issued: {certificate.date}
                          </p>

                          {certificate.link && (
                            <motion.a
                              href={certificate.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center text-sm text-blue-600 dark:text-blue-400 hover:underline"
                              whileHover={{ x: 2 }}
                            >
                              View Certificate <FiExternalLink className="ml-1" />
                            </motion.a>
                          )}
                        </GlassCard>
                      </motion.div>
                    ))}
                  </div>
                </GlassCard>
              </motion.div>
            </motion.div>
          </div>
        </section>
  );
}
